module.exports = __webpack_public_path__ + "static/media/merci.99212e3d.svg";